import React, { Component } from "react";
import { connect } from "react-redux";
import { getReport, submitReport } from "./actions";
import {
    Card,
    CardContent,
    Typography,
    TextField,
    Select,
    MenuItem,
    Button,
    Snackbar,
    SnackbarContent,
} from "@material-ui/core";
import { StyledHeader } from "../../styles";
import { Link } from "react-router-dom";
import { getSLGCheckList, selectReportRequestFailed } from "./selectors";
import { noSig } from "vrcore-dashboard/dist/utilities";
import { noImg } from "vrcore-dashboard/dist/utilities";

class SLGCheckList extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");
        props.getReport(
            path[2].replace(/-/g, "_"),
            path[3],
            path[5].replace(/_/g, " ").replace(/\./g, ":")
        );
        this.state = {
            edit: path[1] === "report-view" ? false : true,
            report: false,
            requestFail: false,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.requestFail === false &&
            prevProps.report !== this.props.report
        ) {
            this.setState({ report: this.props.report });
        } else if (this.props.requestFail === true) {
            this.setState({
                report: false,
                requestFail: this.props.requestFail,
            });
        }
    }
    gridStyle = (length) => {
        return {
            display: "grid",
            gridTemplateRows: `repeat(${length - 1}, 35px)`,
            gridTemplateColumns: `repeat(19, 5.48%)`,
            gridGap: "1px",
            backgroundColor: "black",
            border: "1px solid rgb(4, 71, 107)",
            marginBottom: "10px",
        };
    };

    cellPosition = (rowIndex, columnIndex, rowEnd, columnEnd) => {
        return {
            gridRowStart: `${rowIndex}`,
            gridRowEnd: `${rowEnd}`,
            gridColumnStart: `${columnIndex}`,
            gridColumnEnd: `${columnEnd}`,
        };
    };

    cellStyle = (
        rowIndex,
        columnIndex,
        rowEnd,
        columnEnd,
        fontTrue,
        negative
    ) => {
        let font;
        let bColor = "white";
        let fontColor = "black";
        if (fontTrue) {
            font = `"Handlee", cursive`;
        }
        if (negative) {
            bColor = "rgb(4, 71, 107)";
            fontColor = "white";
        }

        return {
            ...this.cellPosition(rowIndex, columnIndex, rowEnd, columnEnd),
            padding: "4px",
            background: `${bColor}`,
            fontFamily: `${font}`,
            flex: 1,
            display: "flex",
            color: `${fontColor}`,
        };
    };
    headerStyle = (rowIndex, columnIndex, rowEnd, columnEnd) => {
        return {
            ...this.cellPosition(rowIndex, columnIndex, rowEnd, columnEnd),
            padding: "4px",
            backgroundColor: "rgb(4, 71, 107)",
            fontFamily: `auto`,
            flex: 1,
            display: "flex",
            color: "white",
            fontSize: "25px",
        };
    };
    renderItem(key, detail, type) {
        if (this.state.edit === false) {
            if (type === "image") {
                return (
                    <img
                        style={{ width: "50%", height: "50%" }}
                        src={detail}
                        alt="signatureurl"
                    />
                );
            } else if (type === "site") {
                return (
                    <div style={{ alignItems: "center" }}>
                        <img
                            style={{
                                width: "50%",
                                marginRight: "25%",
                                marginLeft: "25%",
                                display: "block",
                            }}
                            src={detail}
                            alt="signatureurl"
                        />
                    </div>
                );
            }
            return detail;
        } else if (this.state.edit === true && this.state.report !== []) {
            if (type === "text") {
                return (
                    <TextField
                        style={{ width: "90%" }}
                        onChange={(event) => {
                            const report = {
                                ...this.state.report,
                                [key]: event.target.value,
                            };
                            this.setState({ report });
                        }}
                        value={this.state.report[key]}
                    />
                );
            } else if (type === "yes/no") {
                return (
                    <Select
                        value={this.state.report[key]}
                        onChange={(event) => {
                            const report = {
                                ...this.state.report,
                                [key]: event.target.value,
                            };
                            this.setState({ report });
                        }}
                    >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                    </Select>
                );
            } else if (type === "image") {
                return (
                    <img
                        style={{ width: "50%", height: "50%" }}
                        src={detail}
                        alt="signatureurl"
                    />
                );
            } else if (type === "site") {
                return (
                    <img
                        style={{ height: "50%" }}
                        src={detail}
                        alt="signatureurl"
                    />
                );
            }
        } else {
            return <Typography variant="body1" />;
        }
    }
    render() {
        const report = this.props.report === false ? false : this.props.report;
        const gStyle = this.gridStyle;
        const cStyle = this.cellStyle;
        const hStyle = this.headerStyle;
        return (
            <Card>
                <StyledHeader>
                    <Typography variant="h5">SLG Checklist</Typography>
                </StyledHeader>
                {report && (
                    <CardContent>
                        <div style={gStyle(2)}>
                            <div style={hStyle(1, 1, 1, 19)}>
                                Traffic Managment Site Inspection Sheet
                            </div>
                            <div style={cStyle(2, 1, 2, 4, false, true)}>
                                Project Name:
                            </div>
                            <div style={cStyle(2, 4, 2, 12, true, false)}>
                                {this.renderItem(
                                    "project_name",
                                    report.project_name,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(2, 12, 2, 16, false, true)}>
                                Phase
                            </div>
                            <div style={cStyle(2, 16, 2, 19, true, false)}>
                                {this.renderItem("phase", report.phase, "text")}
                            </div>
                            <div style={cStyle(3, 1, 3, 4, false, true)}>
                                Date
                            </div>
                            <div style={cStyle(3, 4, 3, 8, true, false)}>
                                {this.renderItem("date", report.date, "text")}
                            </div>
                            <div style={cStyle(3, 8, 3, 12, false, true)}>
                                Time
                            </div>
                            <div style={cStyle(3, 12, 3, 19, true, false)}>
                                {this.renderItem("time", report.time, "text")}
                            </div>
                            <div style={cStyle(4, 1, 4, 12, false, true)}>
                                User Name
                            </div>
                            <div style={cStyle(4, 4, 4, 12, true)}>
                                {report.user_name}
                            </div>
                            <div style={cStyle(4, 12, 4, 19)} />
                        </div>
                        <div style={gStyle(7)}>
                            <div style={hStyle(1, 1, 1, 19)}>
                                1. Traffic Management Set-Up/Modification Checks
                            </div>
                            <div style={hStyle(1, 15, 1, 19)}>Check</div>

                            <div style={cStyle(2, 1, 2, 15, false, false)}>
                                Does the Traffic Management conform to design
                                layout and parameters?
                            </div>
                            <div style={cStyle(2, 15, 2, 19, true, false)}>
                                {this.renderItem(
                                    "chk_1",
                                    report.chk_1,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(3, 1, 3, 15, false, false)}>
                                Have all hazards been addressed in the TM Plan?
                            </div>
                            <div style={cStyle(3, 15, 3, 19, true, false)}>
                                {this.renderItem(
                                    "chk_2",
                                    report.chk_2,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(4, 1, 4, 15, false, false)}>
                                Has allowance been made for the delivery and
                                removal of materials?
                            </div>
                            <div style={cStyle(4, 15, 4, 19, true, false)}>
                                {" "}
                                {this.renderItem(
                                    "chk_3",
                                    report.chk_3,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(5, 1, 5, 15, false, false)}>
                                Is the traffic management for detour routes in
                                place ?
                            </div>
                            <div style={cStyle(5, 15, 5, 19, true, false)}>
                                {this.renderItem(
                                    "chk_4",
                                    report.chk_4,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(6, 1, 6, 15, false, false)}>
                                Have Garda been informed of any Traffic Lights/
                                Stop & Go Boards in use?
                            </div>
                            <div style={cStyle(6, 15, 6, 19, true, false)}>
                                {" "}
                                {this.renderItem(
                                    "chk_5",
                                    report.chk_5,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(7, 1, 7, 15, false, false)}>
                                Have the Garda been informed of Roadworks Speed
                                Limits being introduced?
                            </div>
                            <div style={cStyle(7, 15, 7, 19, true, false)}>
                                {" "}
                                {this.renderItem(
                                    "chk_6",
                                    report.chk_6,
                                    "yes/no"
                                )}
                            </div>
                        </div>

                        <div style={gStyle(21)}>
                            <div style={hStyle(1, 1, 1, 19)}>
                                2. Operation Inspections
                            </div>
                            <div style={cStyle(2, 1, 2, 19, false, true)}>
                                2.1 Operation Checks
                            </div>
                            <div style={cStyle(3, 1, 3, 15, false, false)}>
                                Are the Safety Zones being kept clear of
                                operatives, plant and materials?
                            </div>
                            <div style={cStyle(3, 15, 3, 19, true, false)}>
                                {this.renderItem(
                                    "chk_7",
                                    report.chk_7,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(4, 1, 4, 15, false, false)}>
                                Are all the signs in good condition/ cones in
                                good condition with sleeves?
                            </div>
                            <div style={cStyle(4, 15, 4, 19, true, false)}>
                                {" "}
                                {this.renderItem(
                                    "chk_8",
                                    report.chk_8,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(5, 1, 5, 15, false, false)}>
                                Are the sign vision lines free from bends,
                                hills/dips in road, parked vehicles, hedges etc?
                            </div>
                            <div style={cStyle(5, 15, 5, 19, true, false)}>
                                {this.renderItem(
                                    "chk_9",
                                    report.chk_9,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(6, 1, 6, 15, false, false)}>
                                Will the site be safe at night or in wind, fog,
                                snow or rain?
                            </div>
                            <div style={cStyle(6, 15, 6, 19, true, false)}>
                                {this.renderItem(
                                    "chk_10",
                                    report.chk_10,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(7, 1, 7, 15, false, false)}>
                                Are all misleading permanent signs and road
                                markings covered?
                            </div>
                            <div style={cStyle(7, 15, 7, 19, true, false)}>
                                {this.renderItem(
                                    "chk_11",
                                    report.chk_11,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(8, 1, 8, 15, false, false)}>
                                Is the roadway/footway/cycleway being kept clear
                                of mud and surplus equipment?
                            </div>
                            <div style={cStyle(8, 15, 8, 19, true, false)}>
                                {this.renderItem(
                                    "chk_12",
                                    report.chk_12,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(9, 1, 9, 15, false, false)}>
                                Are materials/plant on verges/lay-bys being
                                properly guarded and lit?
                            </div>
                            <div style={cStyle(9, 15, 9, 19, true, false)}>
                                {this.renderItem(
                                    "chk_13",
                                    report.chk_13,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(10, 1, 10, 19, false, true)}>
                                2.2 Traffic Checks
                            </div>
                            <div style={cStyle(11, 1, 11, 15, false, false)}>
                                Is there safe access to adjacent premises?
                            </div>

                            <div style={cStyle(11, 15, 11, 19, true, false)}>
                                {this.renderItem(
                                    "chk_14",
                                    report.chk_14,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(12, 1, 12, 15, false, false)}>
                                Does the Signing & Guarding meet the (changing)
                                conditions?
                            </div>
                            <div style={cStyle(12, 15, 12, 19, true, false)}>
                                {this.renderItem(
                                    "chk_15",
                                    report.chk_15,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(13, 1, 13, 15, false, false)}>
                                Are traffic control arrangements working at
                                optimum level to reduce traffic delays?
                            </div>
                            <div style={cStyle(13, 15, 13, 19, true, false)}>
                                {this.renderItem(
                                    "chk_16",
                                    report.chk_16,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(14, 1, 14, 15, false, false)}>
                                If present, are the needs of cyclists or horse
                                riders incorporated into the layout?
                            </div>
                            <div style={cStyle(14, 15, 14, 19, true, false)}>
                                {this.renderItem(
                                    "chk_17",
                                    report.chk_17,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(15, 1, 15, 19, false, true)}>
                                2.3 Pedestrians and Vulnerable Road User Check
                            </div>
                            <div style={cStyle(16, 1, 16, 15, false, false)}>
                                Have the needs of pedestrians and vulnerable
                                road users been addressed in the layout?
                            </div>
                            <div style={cStyle(16, 15, 16, 19, true, false)}>
                                {this.renderItem(
                                    "chk_18",
                                    report.chk_18,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(17, 1, 17, 15, false, false)}>
                                If pedestrian route blocked, has a suitable
                                alternative been provided?
                            </div>
                            <div style={cStyle(17, 15, 17, 19, true, false)}>
                                {this.renderItem(
                                    "chk_19",
                                    report.chk_19,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(18, 1, 18, 15, false, false)}>
                                Are pedestrian routes clearly evident/
                                indicated?
                            </div>
                            <div style={cStyle(18, 15, 18, 19, true, false)}>
                                {this.renderItem(
                                    "chk_20",
                                    report.chk_20,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(19, 1, 19, 15, false, false)}>
                                If a footway in the road is used, are ramps to
                                the kerb provided?
                            </div>
                            <div style={cStyle(19, 15, 19, 19, true, false)}>
                                {this.renderItem(
                                    "chk_21",
                                    report.chk_21,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(20, 1, 20, 15, false, false)}>
                                Are pedestrian hazards sufficiently guarded at
                                night?
                            </div>
                            <div style={cStyle(20, 15, 20, 19, true, false)}>
                                {this.renderItem(
                                    "chk_22",
                                    report.chk_22,
                                    "yes/no"
                                )}
                            </div>
                        </div>
                        <div style={gStyle(4)}>
                            <div style={hStyle(1, 1, 1, 19)}>
                                3. Removal Checks
                            </div>
                            <div style={cStyle(2, 1, 2, 15)}>
                                Have all signs, cones, barrier, and lamps been
                                removed?
                            </div>
                            <div style={cStyle(2, 15, 2, 19, true, false)}>
                                {this.renderItem(
                                    "chk_23",
                                    report.chk_23,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(3, 1, 3, 15)}>
                                Have any covered permanent signs been restored?{" "}
                            </div>
                            <div style={cStyle(3, 15, 3, 19, true, false)}>
                                {this.renderItem(
                                    "chk_24",
                                    report.chk_24,
                                    "yes/no"
                                )}
                            </div>

                            <div style={cStyle(4, 1, 4, 15)}>
                                Have Garda been informed that speed limits/
                                signals/ stop and go removed?{" "}
                            </div>
                            <div style={cStyle(4, 15, 4, 19, true, false)}>
                                {this.renderItem(
                                    "chk_25",
                                    report.chk_25,
                                    "yes/no"
                                )}
                            </div>
                        </div>
                        <div style={gStyle(2)}>
                            <div style={hStyle(1, 1, 1, 19)}>
                                4. Exception Report
                            </div>
                            <div style={cStyle(2, 1, 2, 19, true)}>
                                {this.renderItem("notes", report.notes, "text")}
                            </div>
                        </div>
                        <div style={gStyle(3)}>
                            <div style={hStyle(1, 1, 1, 19)}>
                                Interim Checks
                            </div>
                            <div style={cStyle(2, 1, 2, 3)}>
                                <b>Time:</b>
                            </div>
                            <div style={cStyle(3, 1, 3, 3)}>
                                <b>By:</b>
                            </div>
                            <div style={cStyle(2, 3, 2, 5)}>
                                {this.renderItem(
                                    "interim_time_1",
                                    report.interim_time_1,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(3, 3, 3, 5)}>
                                {this.renderItem(
                                    "interim_by_1",
                                    report.interim_by_1,
                                    "text"
                                )}
                            </div>

                            <div style={cStyle(2, 5, 2, 7)}>
                                {this.renderItem(
                                    "interim_time_2",
                                    report.interim_time_2,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(3, 5, 3, 7)}>
                                {this.renderItem(
                                    "interim_by_2",
                                    report.interim_by_2,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(2, 7, 2, 9)}>
                                {this.renderItem(
                                    "interim_time_3",
                                    report.interim_time_3,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(3, 7, 3, 9)}>
                                {this.renderItem(
                                    "interim_by_3",
                                    report.interim_by_3,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(2, 9, 2, 11)}>
                                {this.renderItem(
                                    "interim_time_4",
                                    report.interim_time_4,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(3, 9, 3, 11)}>
                                {this.renderItem(
                                    "interim_by_4",
                                    report.interim_by_4,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(2, 11, 2, 13)}>
                                {this.renderItem(
                                    "interim_time_5",
                                    report.interim_time_5,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(3, 11, 3, 13)}>
                                {this.renderItem(
                                    "interim_by_5",
                                    report.interim_by_5,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(2, 13, 2, 15)}>
                                {this.renderItem(
                                    "interim_time_6",
                                    report.interim_time_6,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(3, 13, 3, 15)}>
                                {this.renderItem(
                                    "interim_by_6",
                                    report.interim_by_6,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(2, 15, 2, 17)}>
                                {this.renderItem(
                                    "interim_time_7",
                                    report.interim_time_7,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(3, 15, 3, 17)}>
                                {this.renderItem(
                                    "interim_by_7",
                                    report.interim_by_7,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(2, 17, 2, 19)}>
                                {this.renderItem(
                                    "interim_time_7",
                                    report.interim_time_8,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(3, 17, 3, 19)}>
                                {this.renderItem(
                                    "interim_by_7",
                                    report.interim_by_8,
                                    "text"
                                )}
                            </div>
                        </div>
                        <div style={gStyle(6)}>
                            <div style={cStyle(1, 1, 6, 6, false, true)}>
                                Check Completed By :{" "}
                                {report.interim_check_completed_by}
                            </div>
                            <div style={cStyle(1, 6, 6, 19, false, false)}>
                                <img
                                    style={{
                                        width: "150px",
                                        height: "150px",
                                        margin: "auto",
                                    }}
                                    src={
                                        report.signature_url === undefined ||
                                        report.signature_url === null ||
                                        report.signature_url === ""
                                            ? noSig
                                            : report.signature_url
                                    }
                                    alt="Signature"
                                />
                            </div>
                        </div>
                        <div style={gStyle(7)}>
                            <div style={hStyle(1, 1, 1, 19)}>Site Images</div>
                            <div style={cStyle(2, 1, 7, 10)}>
                                <img
                                    style={{
                                        width: "150px",
                                        height: "150px",
                                        margin: "auto",
                                    }}
                                    src={
                                        report.photo_1_url === undefined ||
                                        report.photo_1_url === null ||
                                        report.photo_1_url === ""
                                            ? noImg
                                            : report.photo_1_url
                                    }
                                    alt="Site 1"
                                />
                            </div>

                            <div style={cStyle(2, 10, 7, 19)}>
                                <img
                                    style={{
                                        width: "150px",
                                        height: "150px",
                                        margin: "auto",
                                    }}
                                    src={
                                        report.photo_2_url === undefined ||
                                        report.photo_2_url === null ||
                                        report.photo_2_url === ""
                                            ? noImg
                                            : report.photo_2_url
                                    }
                                    alt="Site 2"
                                />
                            </div>
                        </div>

                        {this.state.edit && (
                            <div>
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-edit",
                                        "report-view"
                                    )}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            this.setState({ edit: false });
                                            this.props.submitReport(
                                                this.state.report,
                                                this.props.location.pathname
                                            );
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Link>
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-edit",
                                        "report-view"
                                    )}
                                >
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            this.setState({
                                                edit: false,
                                                report: this.props.report,
                                            });
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </Link>
                            </div>
                        )}
                        {!this.state.edit && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-view",
                                    "report-edit"
                                )}
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        this.setState({ edit: true });
                                    }}
                                >
                                    Edit
                                </Button>
                            </Link>
                        )}
                    </CardContent>
                )}
                {!report && (
                    <CardContent>
                        <Typography variant="caption">
                            Unable to Display Report, Please Contact Admin
                        </Typography>
                    </CardContent>
                )}
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    autoHideDuration={6000}
                    open={this.state.requestFail}
                    onClose={() => {
                        this.setState({ requestFail: false });
                    }}
                >
                    <SnackbarContent message="Report Could Not Be Found, Please Contact Admin" />
                </Snackbar>
            </Card>
        );
    }
}

export default connect(
    (store) => {
        return {
            report: getSLGCheckList(store),
            requestFail: selectReportRequestFailed(store),
        };
    },
    { getReport, submitReport }
)(SLGCheckList);
